import { render } from "./Dropdown.vue?vue&type=template&id=d9be3552"
import script from "./Dropdown.vue?vue&type=script&lang=js"
export * from "./Dropdown.vue?vue&type=script&lang=js"
script.render = render

export default script